import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Header from "../../components/common/Header/Header";
import { AppDispatch } from "../../redux/store";
import RootState from "../../redux/states/root.state";
import { fetchLogs } from "../../redux/actions/logs.actions";
import LogsContainer from "./components/LogsContainer";
import { TerminalLineIcon } from "../../components/common/Icons/Icons";

const LogsPage: React.FC = () => {
  // Data
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.logs);

  useEffect(() => {
    dispatch(fetchLogs(searchParams.toString()))
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <Header
        header="Log History"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><TerminalLineIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Requests</li>
          </ul>
        }
      />
      <main className="lp-main">
        <LogsContainer/>
      </main>
    </div>
  );
};

export default LogsPage;
